import { InputNumber } from "antd";

const defaultRender = (value) => (value ? value : "--");

const columns = (setData) => [
  {
    title: "Employee Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Hours",
    dataIndex: "hours",
    render: (_, record) => (
      <InputNumber
        min={0}
        value={record.hours ?? 0}   // controlled
        className="w-full"
        onChange={(value) =>
          setData((prev) =>
            prev.map((item) =>
              item?.id === record?.id
                ? { ...item, hours: value }
                : item
            )
          )
        }
      />
    ),
  },
  {
    title: "Overtime Hours(if any)",
    dataIndex: "overtime_hour",
    render: (_, record) => (
      <InputNumber
        min={0}
        value={record.overtime_hour ?? 0}
        className="w-full"
        onChange={(value) =>
          setData((prev) =>
            prev.map((item) =>
              item?.id === record?.id
                ? { ...item, overtime_hour: value }
                : item
            )
          )
        }
      />
    ),
  },
  {
    title: "Statutory Holiday(if any)",
    dataIndex: "holidays",
    render: (_, record) => (
      <InputNumber
        min={0}
        value={record.holidays ?? 0}
        className="w-full"
        onChange={(value) =>
          setData((prev) =>
            prev.map((item) =>
              item?.id === record?.id
                ? { ...item, holidays: value }
                : item
            )
          )
        }
      />
    ),
  },
  {
    title: "Rate",
    dataIndex: "rate",
    render: (_, record) => (
      <InputNumber
        min={0}
        value={record.rate ?? 0}
        className="w-full"
        prefix="$"
        onChange={(value) =>
          setData((prev) =>
            prev.map((item) =>
              item?.id === record?.id
                ? { ...item, rate: value }
                : item
            )
          )
        }
      />
    ),
  },
  // {
  //   title: "Amount",
  //   dataIndex: "amount",
  //   render: (_, record) => (
  //     <InputNumber
  //       min={0}
  //       value={record.amount ?? 0}
  //       className="w-full"
  //       onChange={(value) =>
  //         setData((prev) =>
  //           prev.map((item) =>
  //             item?.id === record?.id
  //               ? { ...item, amount: value }
  //               : item
  //           )
  //         )
  //       }
  //     />
  //   ),
  // },
];

export default columns;
